
export default {
  name: 'AtomCircleProgressLoader',
  props: {
    color: {
      required: true,
      type: String,
      default: '#FFF'
    },
    size: {
      required: true,
      type: Number,
      default: 60
    },
    width: {
      required: true,
      type: Number,
      default: 4
    },
    progress: {
      required: true,
      type: Number,
      default: 0
    },
    mirror: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  watch: {
    progress: function () {
      this.updatePercentage()
    }
  },
  mounted() {
    this.updatePercentage()
  },
  methods: {
    updatePercentage() {
      const circle = this.$refs.circle
      const radius = circle.r.baseVal.value
      const circumference = radius * 2 * Math.PI
      circle.style.stroke = `rgba(0,0,0,0.5)`
      let offset = circumference - (this.progress / 100) * circumference
      if (this.mirror) {
        offset = circumference + (this.progress / 100) * circumference
      }
      circle.style.strokeDasharray = `${circumference} ${circumference}`
      circle.style.strokeDashoffset = offset
    }
  }
}
